import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { CellEditEndingEventArgs, CellType, FlexGrid, GridPanel } from '@grapecity/wijmo.grid'
import { QuillViewComponent } from 'ngx-quill'

import { BaseComponent, Grid, Rock } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'

@Component({
    selector: 'app-user-rocks',
    templateUrl: './user-rocks.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        WjInputModule,
        QuillViewComponent,
    ],
})
export class UserRocksComponent extends BaseComponent {
    faSearch = faSearch

    grid: Grid<Partial<Rock>>

    constructor() {
        super()
        this.grid = new Grid<Partial<Rock>>(this.services)
            .filterBy(item => [item.name, item.meetingName])
            .doInitialSelection(false)
            .isReadOnly(false)
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            'RocksRefresh',
            true,
            this.services.data.load(true, true, this.services.data.rocks.queryAllByAction('GetByUserId')).subscribe({
                next: result => {
                    let rocks = result[0] as Rock[]

                    rocks.forEach(x => {
                        if (x.meetingName) {
                            x.meetingName = 'Meeting: ' + x.meetingName
                        } else {
                            x.meetingName = 'Meeting: None'
                        }
                    })

                    rocks = rocks.sort((a, b) => {
                        // First, sort by doneDate: items with doneDate (completed) go to the end
                        const aCompleted = a.doneDate != null
                        const bCompleted = b.doneDate != null

                        if (aCompleted !== bCompleted) {
                            return aCompleted ? 1 : -1 // incomplete items first
                        }

                        // For items with the same completion state, sort by dueDate
                        if (a.dueDate && b.dueDate) {
                            return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime()
                        }

                        // Handle cases where dueDate might be null/undefined
                        if (!a.dueDate && !b.dueDate) return 0
                        if (!a.dueDate) return 1
                        if (!b.dueDate) return -1

                        return 0
                    })

                    this.grid.items = rocks
                },
            }),
        )
    }

    gridItemFormatter = (panel: GridPanel, r, c, cell: HTMLDivElement) => {
        if (panel.cellType === CellType.Cell) {
            const col = panel.grid.columns[c] as any
            const row = panel.grid.rows[r]
            const dataItem = row.dataItem as Partial<Rock>

            // Reset cell class and style due to cell recycling
            cell.classList.remove('yellow-cell')
            cell.style.textDecoration = 'unset'

            if (col.binding === 'doneDate') cell.classList.add('yellow-cell')

            if (dataItem && dataItem.doneDate != null) {
                cell.style.textDecoration = 'line-through'
            }
        }
    }

    cellEditEnded(flexGrid: FlexGrid, args: CellEditEndingEventArgs) {
        if (args.cancel) return
        this.updateRecords([flexGrid.rows[args.row].dataItem])
    }

    updateRecords(items: any[]) {
        this.services.data.rocks.edit(items[0]).subscribe({
            next: () => {
                this.grid.refresh()
            },
            error: () => {
                this.services.notification.error('The rock changes were not successfully saved')
            },
        })
    }
}
